// src/components/AbsoluteNavigation.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useSessionStorage } from '../contexts/SessionStorageContext';
import '../styles/Header.css';

export default function AbsoluteNavigation() {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const { sessionData, clearSessionData } = useSessionStorage();

  // Handle logout with session storage cleanup and navigation
  const handleLogout = async () => {
    try {
      // Clear session storage first
      clearSessionData();
      // Navigate to login immediately
      navigate('/login', { replace: true });
      // Then sign out from Firebase
      await logout();
    } catch (error) {
      console.error('Logout error:', error);
      navigate('/login', { replace: true });
    }
  };

  return (
    <div className="absolute-nav">
      {sessionData.userProfile?.profilePic && (
        <img
          src={sessionData.userProfile.profilePic}
          alt="Profile"
          className={`header__avatar header__avatar--${sessionData.userProfile?.profilePicShape || 'circle'}`}
        />
      )}
      <button className="header__logout" onClick={handleLogout} title="Sign Out">
        <LogOut size={18} />
      </button>
    </div>
  );
}
